//
//
//
//
//
//

export default {
  name: "showCollapse-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};